<div class="container">
  <div class="header">
    <h1>Gerenciamento de Convites</h1>
    <button mat-raised-button color="primary" (click)="openCreateInvitationDialog()">
      Novo Convite
    </button>
  </div>

  <mat-button-toggle-group [(ngModel)]="selectedStatus" (change)="onStatusChange($event.value)" class="filter-group">
    <mat-button-toggle value="ACTIVE">Ativos</mat-button-toggle>
    <mat-button-toggle value="INACTIVE">Inativos</mat-button-toggle>
  </mat-button-toggle-group>

  <div *ngIf="isLoading" class="loading-shade">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="!isLoading && invitations.length > 0" class="invitations-list">
    <mat-card *ngFor="let invitation of invitations" class="invitation-card">
      <mat-card-header>
        <mat-card-title>{{ invitation.username }}</mat-card-title>
        <mat-card-subtitle>{{ invitation.condominium.name }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>Criado em: {{ invitation.createTime | date: 'dd/MM/yyyy HH:mm' }}</p>
        <p>Expira em: {{ invitation.expirationTime | date: 'dd/MM/yyyy HH:mm' }}</p>
        <p>Status: {{ invitation.accepted ? 'Aceito' : (invitation.deleted ? 'Expirado/Cancelado' : 'Pendente') }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-icon-button (click)="deleteInvitation(invitation.id)" [disabled]="invitation.accepted || invitation.deleted">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <div *ngIf="!isLoading && invitations.length === 0" class="no-invitations">
    <p>Nenhum convite encontrado.</p>
  </div>

  <mat-paginator *ngIf="page"
                 [length]="page.totalElements"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)">
  </mat-paginator>
</div>
